export const TEST_ID = 'detailsViewEntityLinkContainer';
